import React from 'react';
import List from 'containers/rest/List';
import RestFieldItem from 'components/RestField/RestFieldItem';
import ActionGroup from 'components/RestActions/ActionGroup';
import EditButton from 'components/RestActions/EditButton';
import { PreviewHtml } from 'components/RestInput/RestEditor';

const NichesList = (props) => (
  <List
    {...props}
    defaultOptions={{ customApiResource: 'niches/me' }}
    resource="niches"
  >
    <RestFieldItem source="name" header="niches.name" />
    <RestFieldItem
      format={(data) => <PreviewHtml html={data} />}
      source="description"
      header="niches.description"
    />
    <ActionGroup>
      <EditButton />
    </ActionGroup>
  </List>
);

NichesList.propTypes = {};

export default NichesList;
